import { Controller } from "@hotwired/stimulus"
import { enter, leave, toggle } from "el-transition"

export default class extends Controller {
  // to use something other than `hidden` for the css class:
  //   add this to the element `data-reveal-hidden-class="invisible"`
  static targets = ["container", "backdrop", "panel", "closeButton"]
  static classes = [ "hidden" ]
   static values = {
    class: String
  }

  connect() {
    this.class = this.hasHiddenClass ? this.hiddenClass : "hidden"
  }

  show() {
    this.containerTarget.classList.remove("hidden");
    enter(this.backdropTarget);
    enter(this.closeButtonTarget);
    enter(this.panelTarget);
  }

  hide() {
    Promise.all([
      leave(this.backdropTarget),
      leave(this.closeButtonTarget),
      leave(this.panelTarget),
    ]).then(() => {
      this.containerTarget.classList.add("hidden");
    });
  }
}
